import React from 'react';
import { ErrorBoundary } from '../error-boundary';
import { History, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ConversationErrorBoundaryProps {
  children: React.ReactNode;
}

export function ConversationErrorBoundary({ children }: ConversationErrorBoundaryProps) {
  const handleError = (error: Error) => {
    // Log conversation-specific error context
    console.error('Conversation history error:', error);
  };

  const conversationErrorFallback = (
    <div className="flex items-center justify-center p-4 rounded-lg bg-muted/30">
      <div className="text-center space-y-3">
        <History className="h-6 w-6 text-muted-foreground mx-auto" />
        <div>
          <h3 className="text-sm font-medium">Unable to load conversations</h3>
          <p className="text-xs text-muted-foreground">
            There was a problem loading your chat history.
          </p>
        </div>
        <Button 
          size="sm" 
          variant="outline" 
          onClick={() => window.location.reload()}
          className="text-xs"
        >
          <RefreshCw className="mr-1 h-3 w-3" />
          Retry
        </Button>
      </div>
    </div>
  );

  return (
    <ErrorBoundary
      level="component"
      onError={handleError}
      fallback={conversationErrorFallback}
    >
      {children}
    </ErrorBoundary>
  );
}
